import React from 'react';
import {observable, action, computed, makeObservable, runInAction} from 'mobx';
import {observer} from 'mobx-react';
import store from './s';
import Shipping from './components/shipping/shipping';
import CartSummary from './components/cart/cartSummary';
import Cart from './components/cart/cart';
import CheckoutAccount from './components/checkoutaccount/checkoutAccount';
import Payment from './components/payment/payment';
import '../style/style.scss';
import {checkout} from '../api';
import Oci from './components/oci/oci';
import Confidence from './components/confidence';
import * as util from '../util';
import PaypalAdv from './components/payment/paypal-advanced';
import ModalFastShipping from './components/modals/fast-shipping';
import ModalShippingInfoThirdParty from './components/modals/shipping-third-party-info';
import OrderProcessing from './components/modals/order-processing';
import SpecialProcessing from './components/modals/checkout-updating';
import ShippingEst from './components/modals/shipping-est-postal';
import ModalSimple from '../global/modal-simple';
import AbTestStore, {ABTestKeys} from '../global/store/ab-test.store';
import * as emitter from '../global/emitter';
import ModalCartMobile from './components/cart/ab-test/cart-mobile.modal';
import ReturnPolicyModal from './components/modals/return-policy.modal';
import {screenResizeStore} from '../global/store/screen-resize-store';

declare var openz: any;
declare var window: any;
declare var __company_name: string;
declare var __domain_name: string;

const defaultStyle = {
    transition: `opacity ${100}ms ease-in-out`,
    opacity: 0,
};

const transitionStyles = {
    entering: {opacity: 0},
    entered: {opacity: 1},
};

declare var OpenLHNChat: any;
declare const modalOpen: (id: string) => void;

@observer
class CheckoutComponent extends React.Component {
    @observable hasLoadedCart: boolean = false;
    @observable hasLoadedEstimates: boolean;
    @observable statePaymentIn: boolean = false;
    @observable hasError: boolean = false;
    @observable logo_png: string = `https://${store.Portal.CDNDomain}/images/cached/general/logo_45.png`;
    @observable logo_webp: string = `https://${store.Portal.CDNDomain}/images/cached/general/logo_45.webp`;

    constructor(props) {
        super(props);
        this.getCart = this.getCart.bind(this);
        this.getEstimated = this.getEstimated.bind(this);
        this.checkFastShipWarning = this.checkFastShipWarning.bind(this);
        this.ab_update = this.ab_update.bind(this);
        // this.hasLoadedCart = false;
        this.hasLoadedEstimates = false;
        this.hasError = false;
        makeObservable(this);
        window.react_checkout = this;

        if (store.PortalID > 0) {
            this.logo_png = `${store.Portal.LogoURL}.png`;
            this.logo_webp = `${store.Portal.LogoURL}.webp`;
        }
    }

    @action
    ab_update(_key: string, _value: number) {
        window.ab[_key] = _value;
        if (!AbTestStore.ab) {
            AbTestStore.ab = {};
        }
        AbTestStore.ab[_key] = _value;
        emitter.eventEmitter.dispatch(emitter.EventType.AB, 'ab');
    }

    componentDidMount() {
        if (store.checkout == undefined) {
            store.initCheckout();
        }
        this.getCart();
    }

    @action
    getCart = async () => {
        const hasLoadedCart = await checkout('get-cart');

        runInAction(() => {
            // approved ria
            this.hasLoadedCart = hasLoadedCart;
            if (store.checkout.ship === null) {
                store.checkout.ship = store.getEmptyShipping();
            }
            if (store.checkout.billing === null) {
                store.checkout.billing = store.getEmptyBilling();
            }

            this.getEstimated();
        });
    };

    @action
    checkFastShipWarning = () => {
        if (store.checkout.is_fast_shipping && store.checkout.is_fast_shipping_broken && !store.checkout.received_fast_ship_warning) {
            store.checkout.received_fast_ship_warning = true;
            modalOpen('modal-fast-shipping');
        }
    };

    @action
    getEstimated = async () => {
        if (store.checkout.cstep !== ICheckoutStep.cart || this.hasLoadedEstimates) {
            return;
        }
        this.hasLoadedEstimates = true;
        store.uiCheckout.isLoadingEstimated = true;
        await checkout('get-est');

        runInAction(() => {
            // approved ria
            store.uiCheckout.isLoadingEstimated = false;
            this.checkFastShipWarning();
        });
    };

    @computed get cartItemTotal() {
        return store.checkout.cart.items.map(o => o.qty).reduce((a, b) => a + b, 0);
    }

    @computed get isZeroOrder() {
        return (
            !store.checkout.isMyFrames && store.checkout.cstep === ICheckoutStep.payment && store.checkout.cart.pricing.total <= 0 && (store.checkout.cart.pricing.discount != 0 || store.checkout.cart.pricing.gift != 0) && store.checkout.code_promo.value && store.checkout.code_promo.value.length > 0
        );
    }

    @computed get isTestOrder() {
        try {
            return store.checkout.notes_customer.toLowerCase().includes('marketing-test-order') || store.checkout.notes_gift.toLowerCase().includes('marketing-test-order');
        } catch (err5) {
            return false;
        }
    }

    render() {
        if (store.checkout == undefined) {
            return <div>Error 0</div>;
        }

        const showCarSummary = AbTestStore.ABIsVariant(ABTestKeys.ab_checkout_1, 1) ? store.checkout.cstep !== ICheckoutStep.cart : true;

        return (
            <div className={`checkout font-${store.PortalID}`}>
                <div className="checkout-v4-skin-header">
                    <div className="logo">
                        <a
                            href={store.checkout.isMyFrames ? ' /MyFrames' : '/'}
                            aria-label={`${__company_name} | Diploma Frame | Go to homepage`}
                        >
                            <picture>
                                <source
                                    type="image/webp"
                                    srcSet={this.logo_webp}
                                />
                                <img
                                    className="resp"
                                    src={this.logo_png}
                                    alt=""
                                    width={360}
                                    style={{aspectRatio: store.PortalID === 0 ? '8/1' : '4.3/1', objectFit: 'contain'}}
                                    height={store.PortalID === 0 ? '45' : '84'}
                                    loading="lazy"
                                />
                            </picture>
                        </a>
                    </div>

                    {store.checkoutABSkip === 2 && store.checkout.cstep === ICheckoutStep.oci && store.checkout.cart.items && store.checkout.cart.items.length > 0 && screenResizeStore.width > 767 && (
                        <div
                            className="continue-shopping"
                            style={{marginLeft: 25, marginRight: 'auto'}}
                        >
                            <a
                                href={store.checkout.cart.items[store.checkout.cart.items.length - 1].StoreURL}
                                className="underline"
                                aria-label="Continue Shopping"
                                style={{fontSize: 14}}
                            >
                                Continue Shopping {store.checkout.cart.items && store.checkout.cart.items.length > 0 && store.checkout.cart.items[0].title1}
                            </a>
                        </div>
                    )}

                    <div>
                        <div>
                            {store.checkout.isMyFrames && (
                                <a
                                    href="/MyFrames"
                                    aria-label="Back to MyFrames"
                                >
                                    <h1 className="zero">MyFrames Checkout</h1>
                                </a>
                            )}
                            {!store.checkout.isMyFrames && <h1 className="zero">Checkout</h1>}
                        </div>
                        <div>
                            <span className="chat-desktop d-none d-md-inline">
                                {store.Portal.CustomerServicePhone && (
                                    <a
                                        href={util.getPhoneHREF()}
                                        style={{color: '#595959'}}
                                    >
                                        {store.Portal.CustomerServicePhone}
                                    </a>
                                )}
                                <span style={{paddingLeft: 12, paddingRight: 4, whiteSpace: 'nowrap'}}>
                                    <span style={{paddingRight: 4, color: '#595959'}}>
                                        <i
                                            className="fas fa-comment-alt-dots"
                                            aria-hidden={true}
                                        />
                                    </span>
                                    <button
                                        style={{color: '#595959'}}
                                        onClick={e => {
                                            openz();
                                            e.preventDefault();
                                        }}
                                        className="text-btn"
                                        aria-label="Chat"
                                        type="button"
                                        aria-haspopup="dialog"
                                    >
                                        Chat
                                    </button>
                                </span>
                            </span>
                            <span
                                style={{whiteSpace: 'nowrap'}}
                                className="d-none d-md-inline"
                            >
                                <button
                                    className="link cart-icon text-btn"
                                    onClick={e => {
                                        store.moveStep(ICheckoutStep.cart);
                                        e.preventDefault();
                                    }}
                                    aria-label="Back to cart"
                                    type="button"
                                >
                                    <span style={{paddingRight: 6}}>
                                        <i className="fas fa-shopping-cart" />
                                    </span>
                                    {this.cartItemTotal}
                                </button>
                            </span>
                        </div>
                    </div>
                </div>

                {!this.hasLoadedCart && (
                    <div className="checkout-loader">
                        <div>
                            <i className="fas fa-circle-notch fa-spin fast-spin"></i>
                        </div>
                        <div>Retrieving Cart</div>
                    </div>
                )}

                {!this.hasError && this.hasLoadedCart && (
                    <div className="row no-gutters">
                        {store.checkout.cstep === ICheckoutStep.cart && AbTestStore.ABIsVariant(ABTestKeys.ab_checkout_1, 1) && (
                            <div className="d-block d-md-none">
                                <ModalCartMobile />
                            </div>
                        )}

                        {showCarSummary && (
                            <div className="col-12 d-block d-md-none">
                                <CartSummary isMobile={true} />
                            </div>
                        )}

                        <div className="col-12 col-md-8 col-md-8 order-2 order-sm-1">
                            {store.checkout.cstep >= ICheckoutStep.oci && <Oci />}
                            {store.checkout.cstep === ICheckoutStep.cart && <Cart />}
                            {store.checkout.cstep === ICheckoutStep.checkout && <CheckoutAccount />}
                            {store.checkout.cstep >= ICheckoutStep.oci && <Shipping />}
                            {store.checkout.cstep >= ICheckoutStep.oci && <Payment />}
                            {!store.checkout.isMyFrames && !this.isZeroOrder && !this.isTestOrder && store.checkout.cstep === ICheckoutStep.payment && (
                                <div
                                    className={store.checkout.cstep === ICheckoutStep.payment ? '' : 'vv-none'}
                                    style={{maxWidth: 750, margin: '0 auto', paddingTop: 12}}
                                >
                                    <PaypalAdv />
                                </div>
                            )}
                        </div>
                        <div className="d-none d-md-block col-12 col-md-4 col-lg-4 order-1 order-sm-2">
                            <CartSummary isMobile={false} />
                        </div>
                    </div>
                )}

                {this.hasError && (
                    <div style={{paddingTop: 24}}>
                        <hr />A checkout error has occurred.
                        <ul>
                            <li>If you placed an order, we likely received payment for your order. Please contact us at {store.Portal.CustomerServicePhone} to verify your order.</li>
                            <li>Otherwise please click here to reset your cart: </li>
                        </ul>
                        <div style={{paddingLeft: '5%'}}>
                            <button
                                type="button"
                                className={`btn btn-checkout btn-checkout-yellow${store.PortalID === 3 ? ' btn-checkout-yellow-portal3' : ''}`}
                            >
                                Continue
                            </button>
                        </div>
                        <div style={{paddingTop: 48}}>Error details:</div>
                        <div className="alert alert-danger">
                            <div className="b">{store.errorLog}</div>
                            <div>{JSON.stringify(store.errorLogInfo)}</div>
                        </div>
                    </div>
                )}

                <div
                    className="d-none d-md-block"
                    style={{marginTop: '15%'}}
                />

                <div className="row d-block d-md-none">
                    <div
                        className="col-12"
                        style={{padding: '20px 0'}}
                    >
                        <div className="hr" />
                        <Confidence />
                        <div className="hr" />
                    </div>
                </div>

                <div className="row row-footer">
                    <div className="col-12 col-md-9 col-footer col-footer-1">
                        {store.Portal.CustomerServicePhone && (
                            <span>
                                <a href={util.getPhoneHREF()}>{store.Portal.CustomerServicePhone}</a>
                            </span>
                        )}
                        {store.PortalID < 1 && (
                            <span>
                                <button
                                    style={{fontSize: '12px'}}
                                    onClick={e => {
                                        openz();
                                        e.preventDefault();
                                    }}
                                    className="text-btn"
                                    type="button"
                                    aria-label="Chat"
                                    aria-haspopup="dialog"
                                >
                                    <span style={{paddingRight: 4, color: '#999'}}>
                                        <i
                                            className="fas fa-comment-alt-dots"
                                            aria-hidden={true}
                                        />
                                    </span>{' '}
                                    Chat
                                </button>
                            </span>
                        )}
                        {store.PortalID < 4 && (
                            <span
                                tabIndex={0}
                                className="link pointer underline"
                                onClick={e => {
                                    modalOpen('modal-return-policy');
                                    e.preventDefault();
                                }}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        modalOpen('modal-return-policy');
                                        e.preventDefault();
                                    }
                                }}
                            >
                                {store.PortalID === 3 ? '30' : '120'}-Day Return Policy
                            </span>
                        )}
                        {store.PortalID < 1 && (
                            <span>
                                <a
                                    href="/customer-service/frequently-asked-questions-faq"
                                    tabIndex={0}
                                >
                                    FAQ
                                </a>
                            </span>
                        )}
                        {store.PortalID < 1 && (
                            <span>
                                <a
                                    href="/customer-service"
                                    tabIndex={0}
                                >
                                    Customer Service
                                </a>
                            </span>
                        )}
                        <span>
                            <a
                                href={store.PortalID < 3 ? '/about-us/accessibility-statement' : '/accessibility-statement'}
                                tabIndex={0}
                            >
                                Accessibility Statement
                            </a>
                        </span>

                        <span style={{fontSize: '12px', cursor: 'default'}}>
                            Secure Checkout{' '}
                            <span style={{paddingLeft: 4}}>
                                <i
                                    className="fas fa-lock"
                                    aria-hidden={true}
                                ></i>
                            </span>
                        </span>
                    </div>

                    <div
                        className="col-12 col-md-3 col-footer text-right"
                        style={{fontSize: '12px'}}
                    >
                        <span style={{cursor: 'inherit'}}>
                            &copy; {__company_name} {new Date().getFullYear().toString()}
                        </span>
                    </div>
                </div>

                <ModalShippingInfoThirdParty />
                <ReturnPolicyModal portalID={store.PortalID} />
                <ModalFastShipping />
                <ShippingEst />
                {store.uiCheckout.processing && <OrderProcessing />}
                {store.uiCheckout.isSpecialProcessing && <SpecialProcessing />}

                <ModalSimple
                    id="modal-missing-shipping"
                    title={'Shipping Information Missing'}
                >
                    <div className="modal-body text-left">Your shipping information could not be obtained from your payment provider. Please input your address and continue to checkout - your preferred payment method can still be used.</div>
                </ModalSimple>
            </div>
        );
    }
}
export default CheckoutComponent;
